import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=2166f99e&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
import style0 from "./modal.vue?vue&type=style&index=0&id=2166f99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166f99e",
  null
  
)

export default component.exports